import * as React from 'react';

import * as styles from './PromotionSectionHeaderLayout.css';

interface IPromotionSectionHeaderLayoutProps {
  header: React.ReactNode;
  mobile: boolean;
  subheader: React.ReactNode;
}

export const PromotionSectionHeaderLayout = ({ mobile, subheader, header }: IPromotionSectionHeaderLayoutProps) => {
  return (
    <div>
      {header}

      {!mobile && <div className={styles.subheader}>{subheader}</div>}
    </div>
  );
};
